"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PulsingDot = void 0;
var PulsingDot_1 = require("./PulsingDot");
Object.defineProperty(exports, "PulsingDot", { enumerable: true, get: function () { return PulsingDot_1.PulsingDot; } });
